import { useState, useEffect } from "react"

const useFetch = ({ url, opt, args, fn }) => {
  const [data, setData] = useState(null)
  const [isPending, setIsPending] = useState(true)
  const [err, setErr] = useState(null)

  useEffect(() => {
    const abortCtrl = new AbortController()

    // en caso de pasar una funcion como url, esta (la funcion) debe retornar
    // un objeto {url, opt}
    if (typeof url === "function")
      // eslint-disable-next-line
      ({ url, opt } = url(args ? args : {}))

    const options = Object.assign({ signal: abortCtrl.signal }, opt)

    fetch(url, options)
      .then((res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            throw new Error(text)
          })
        }

        return res.json()
      })
      .then((data) => {
        data = fn ? fn(data) : data
        setData(data)
        setIsPending(false)
        setErr(null)
      })
      .catch((err) => {
        if (err.name === "AbortError") return

        // en modo debug, el servidor retorna un error en html
        // en modo produccion, el servidor retorna un JSON
        // entonces:
        let errData = err.message
        try {
          errData = JSON.parse(err.message)
        } catch (error) {}

        const isServerErr = (err) =>
          ["detail", "status", "title", "type"].every((attr) =>
            err.hasOwnProperty(attr)
          )

        setErr(isServerErr(errData) ? errData : { err: "Error interno" })
      })

    // cleanup func
    return () => abortCtrl.abort()
  }, [url, opt, args, fn])

  return [data, isPending, err, setData]
}

export default useFetch
